var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarNoticeboardGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1.5C13.75 1.16848 13.8817 0.850537 14.1161 0.616116C14.3505 0.381696 14.6685 0.25 15 0.25H17.5C17.8315 0.25 18.1495 0.381696 18.3839 0.616116C18.6183 0.850537 18.75 1.16848 18.75 1.5V16.5H19.375C19.5408 16.5 19.6997 16.5658 19.8169 16.6831C19.9342 16.8003 20 16.9592 20 17.125C20 17.2908 19.9342 17.4497 19.8169 17.5669C19.6997 17.6842 19.5408 17.75 19.375 17.75H0.625C0.45924 17.75 0.300269 17.6842 0.183058 17.5669C0.065848 17.4497 0 17.2908 0 17.125C0 16.9592 0.065848 16.8003 0.183058 16.6831C0.300269 16.5658 0.45924 16.5 0.625 16.5H1.25V12.75C1.25 12.4185 1.3817 12.1005 1.61612 11.8661C1.85054 11.6317 2.16848 11.5 2.5 11.5H5C5.33152 11.5 5.64946 11.6317 5.88388 11.8661C6.1183 12.1005 6.25 12.4185 6.25 12.75V16.5H7.5V7.75C7.5 7.41848 7.6317 7.10054 7.86612 6.86612C8.10054 6.6317 8.41848 6.5 8.75 6.5H11.25C11.5815 6.5 11.8995 6.6317 12.1339 6.86612C12.3683 7.10054 12.5 7.41848 12.5 7.75V16.5H13.75V1.5ZM15 16.5H17.5V1.5H15V16.5ZM11.25 16.5V7.75H8.75V16.5H11.25ZM5 16.5V12.75H2.5V16.5H5Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNoticeboardGray);
export default __webpack_public_path__ + "static/media/sidebar-noticeboard-gray.42840f4d5534f473b4cc9ada87f4f202.svg";
export { ForwardRef as ReactComponent };